import { render, staticRenderFns } from "./InComingSurgeries.vue?vue&type=template&id=27f261dc"
import script from "./InComingSurgeries.vue?vue&type=script&lang=js"
export * from "./InComingSurgeries.vue?vue&type=script&lang=js"
import style0 from "./InComingSurgeries.vue?vue&type=style&index=0&id=27f261dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports